import { useState } from 'react';
import '../styles/About.css';

const WORK_EXPERIENCE = [
  {
    company: 'TikTok',
    image: '/images/tiktok.png',
    imageSize: '80%',
    description: [
      'Machine Learning Engineer at BRIC (2026)',
      'Worked with the BRIC team to build end to end pipelines for review and transaction moderation',
      'Skills: Python, SQL, Spark, ML Model Deployment'
    ]
  },
  {
    company: 'Defense Science Tech Agency',
    image: '/images/dsta.png',
    imageSize: '100%',
    description: [
      'AI Engineer at MINDEF Digital Services (2025) and C3D (2023)',
      'Implemented a large language model (LLM) integration for SAF deferment system',
      'Engineered a Speech to Text (STT) and Text to Speech (TTS) pipeline'
    ]
  },
  {
    company: 'National University of Singapore',
    image: '/images/nus.png',
    imageSize: '90%',
    description: [
      'Teaching Assistant and Grader for BT2102 Data Management and Visualisation',
      'Teaching Assistant for IS2108 Full-stack Software Engineering I',
      'UROP student researching on CyberSecurity and LLMs',
    ]
  },
  {
    company: 'Ministry of Manpower',
    image: '/images/mom.png',
    imageSize: '100%',
    description: [
      'Content Developer Intern at Digital Services (2021)',
      'Managed International Migrants\' Day 2022 Exhibition',
      'Spearheaded Content Creation for MOM\'s Facebook Page'
    ]
  }
];

const EDUCATION = [
  {
    year: 'Aug 2023 - Aug 2027',
    school: 'National University of Singapore',
    description: [
      'Hackathons: TikTok Tech Jam (6th Place, only soloist, honorary mention), SMU Tech Ellipsis (3rd Place)',
      'Undergraduate Research Programme (UROP) on CyberSecurity and LLMs [Aug 2025 - Nov 2025] ',
      'Grader for BT2102 Data Management and Visualisation [Aug 2025 - Nov 2025]',
      'Teaching Assistant for BT2102 Data Management and Visualisation [Jan - May 2025]',
      'Harvard Undergraduate in Asia Programme, Logistics Chair  [2024 - 2025]',
      'Google Developer\'s Student Club (GDSC) Internal Team [2023]',
      'NUS College Student (Honors Programme) [2023 - Present]'
    ]
  },
  {
    year: 'Jan 2021 - Dec 2022',
    school: 'Raffles Institution ',
    description: [
      '90/90 Rank points (full UAS score) for A levels',
      'Read H2 Mathematics, H2 English Language Linguistics, H2 Chemistry, H2 Biology, H1 General Paper, H1 Project Work at A levels.',
      'Received the English Language Lingustic Scholarship (ELES)',
      'Received the Edusave Scholarship for Independent Schools (ESIS)',
      'Receieved the Edusave Award for Achievement, Good Leadership and Service for 2 years (2021, 2022)',
      'Elected as the Vice House Captain of Hadley Hullett House Directorate',
      'Elected as Student Councillor by the student body to be part of Raffles Institution 41st Students\' Council'
    ]
  },
  {
    year: 'Jan 2017 - Nov 2020',
    school: 'Tanjong Katong Girls\' School',
    description: [
      'Achieved a perfect net score of 2 and raw score of 6 at O levels',
      'Appointed as Secretary (Head of Secretariat and Finance) of Prefectorial Board Executive Committee (PBEXCO)',
      'Recipient of Edusave Scholarship for all 4 years (2020, 2019, 2018, 2017)',
      'Recipient of the subject prize for English Literature for all 4 years (2020, 2019, 2018, 2017)',
      'Recipient of Edusave Award for Achievement, Good Leadership and Service (2021,2022)'
    ]
  }
];

const Portfolio = () => {
  const [expanded, setExpanded] = useState({});

  const toggleExpand = (i) => {
    setExpanded((prev) => ({ ...prev, [i]: !prev[i] }));
  };

  return (
    <section className="about-section">
      <h2 className="section-title">Work Experience</h2>
      <div className="project-cards">
        {WORK_EXPERIENCE.map((item, i) => (
          <div
            className={`project-card ${expanded[i] ? 'expanded' : ''}`}
            key={i}
            onClick={() => toggleExpand(i)}
          >
            <div className="project-card-image">
              <img src={item.image} alt={item.company} className="project-card-img" style={{ width: item.imageSize, height: item.imageSize }} />
            </div>
            {!expanded[i] && <span className="project-card-hint">Click to see more</span>}
            <div className="project-card-content">
              <h3 className="project-card-title">{item.company}</h3>
              <ul className="project-card-description">
                {item.description.map((line, j) => (
                  <li key={j}>{line}</li>
                ))}
              </ul>
              <span className="project-card-toggle">
                {expanded[i] ? '✕ Click to close' : '+ Click to expand'}
              </span>
            </div>
          </div>
        ))}
      </div>

      <h2 className="section-title">Education</h2>
      <div className="edu-timeline">
        {EDUCATION.map((item, i) => (
          <div className="edu-timeline-item" key={i}>
            <div className="edu-year">{item.year}</div>
            <div className="edu-line-connector"></div>
            <div className="edu-details">
              <h3 className="edu-school">{item.school}</h3>
              <ul className="edu-description">
                {item.description.map((line, j) => (
                  <li key={j}>{line}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
